// extracted by mini-css-extract-plugin
export default {"abstractSection":"abstract-section_abstractSection__QJTUA"};